import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
export var getQueryParams = function getQueryParams() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var search = location.search;
  if (!search) return {};
  return search.slice(1).split('&').reduce(function (prev, cur) {
    var _cur$split = cur.split('='),
        _cur$split2 = _slicedToArray(_cur$split, 2),
        key = _cur$split2[0],
        value = _cur$split2[1];

    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, decodeURIComponent(value)));
  }, {});
};
export var getQueryParamsWithSpecialChars = function getQueryParamsWithSpecialChars() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _location$href$split = location.href.split('?'),
      _location$href$split2 = _slicedToArray(_location$href$split, 2),
      search = _location$href$split2[1];

  if (!search) return {};
  return search.split('&').reduce(function (prev, cur) {
    var _cur$split3 = cur.split('='),
        _cur$split4 = _slicedToArray(_cur$split3, 2),
        key = _cur$split4[0],
        value = _cur$split4[1];

    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, decodeURIComponent(value)));
  }, {});
};
export var getUrlObject = function getUrlObject(urlStr) {
  var urlObject;

  if (!urlStr) {
    return urlObject;
  }

  try {
    urlObject = new URL(urlStr);
  } catch (err) {
    // eslint-disable-next-line
    console.warn(err);
  }

  return urlObject;
};
export var getMainDomainName = function getMainDomainName() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var splittedDomain = domain.split('.'); // www.bybit.com --> bybit.com
  // www.bybit.com.hk --> bybit.com.hk

  return splittedDomain.slice(-(splittedDomain.length - 1)).join('.');
};
export var isFromInternalByMainDomain = function isFromInternalByMainDomain() {
  var hostnameA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hostnameB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var domainA = getMainDomainName(hostnameA);
  var domainB = getMainDomainName(hostnameB);
  if (domainA === domainB) return true;
  return false;
};